import React, {Component} from 'react';
import {ViewTitle} from 'admin-on-rest/lib/mui';
import TransferListByProductTable from '../components/TransferListByProductTable';
import TransferredProductsSearchFilter from '../components/TransferredProductsSearchFilter';
import Avatar from 'material-ui/Avatar';
import {Card, CardText} from 'material-ui/Card';
import CircularProgress from 'material-ui/CircularProgress';
import Icon from 'material-ui/svg-icons/action/description';

export class TransferredProductsList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filterSubmitted: false,
            filterValues: {
                receivedCondition: '',
                searchName: '',
                startDate: null,
                startDateStr: '',
                transferType: ''
            },
            listComplete: false,
            loading: false
        };
    }

    handleFilterSubmit = (obj) => {
        const date = (obj && obj.date) ? obj.date : null;
        const receivedCondition = (obj && obj.receivedCondition) ? obj.receivedCondition : '';
        const searchName = (obj && obj.searchName) ? obj.searchName : '';
        const transferType = (obj && obj.transferType) ? obj.transferType : '';
        if (date && receivedCondition && searchName && transferType) {
            const searchDate = new Date(date);
            const str = searchDate.getUTCMonth() + 1 + '/' + searchDate.getUTCDate() + '/' + searchDate.getUTCFullYear();
            this.setState({
                filterSubmitted: true,
                filterValues: {
                    receivedCondition: receivedCondition,
                    searchName: searchName,
                    startDate: date,
                    startDateStr: str,
                    transferType: transferType
                },
                loading: true,
                listComplete: false
            });
        }
    };

    handleListComplete = (isComplete) => {
        this.setState({
            listComplete: isComplete,
            loading: false
        });
    };

    assembleTitle = (fv) => {
        let str = '';
        if (fv.receivedCondition !== 'any') {
            str += (fv.receivedCondition === 'received') ? 'Received ' : 'Incoming ';
        }
        if (fv.transferType !== 'any') {
            str += (fv.transferType === 'retailbox') ? 'Retail Boxes ' : 'Repacks ';
        } else {
            str += ' Transfers ';
        }
        str += 'containing "' + fv.searchName + '" since ' + fv.startDateStr;
        return str;
    };

    render() {
        const {
            filterSubmitted,
            filterValues,
            listComplete,
            loading
        } = this.state;

        const ListTitle = <span className="list-title">
            <Avatar icon={<Icon/>} className="avatar-title"/>Transferred Products</span>;

        const ListDescription = () => {
            return (
                <span>
                    <p>Search for Products contained in transfers since a specified date. Select a Date Since, a
                        transfer status, whether the Product is in a Repack or Retail Box, and enter a search term.</p>
                    <p>For Transfers, click its <strong>View</strong> icon to view the Transfer.</p>
                    <p>For Repacks and Retail Boxes, click its <strong>Products</strong> icon to view the Products
                        contained in the collection, <strong>View</strong> to view,
                        and <strong>Edit</strong> to edit.</p>
                </span>
            );
        };

        const reportTitle = this.assembleTitle(filterValues);

        return (
            <div className="list-container">
                <Card>
                    <ViewTitle title={ListTitle}/>
                    <CardText>
                        <ListDescription/>

                        <TransferredProductsSearchFilter loading={loading} onSubmitFilter={this.handleFilterSubmit}/>

                        {filterSubmitted &&
                            <div>
                                {(loading || listComplete) &&
                                    <h3>{reportTitle}</h3>
                                }

                                {loading && !listComplete &&
                                    <div className="loader-container">
                                        <h4>Searching for "{filterValues.searchName}"...</h4>
                                        <CircularProgress
                                            size={24}
                                            thickness={2}
                                            className="loader"
                                        />
                                    </div>
                                }

                                <TransferListByProductTable
                                    basePathCollections="InventoryRepacksRetailBoxes"
                                    basePathTransfers="InventoryTransfers"
                                    filterValues={filterValues}
                                    listComplete={listComplete}
                                    onDataComplete={this.handleListComplete}
                                />
                            </div>
                        }
                    </CardText>
                </Card>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Fuse/Inventory/TransferredProductsList.js